import axios from 'axios'
import config from '../config'

export default {
    getEmailDomains() {
        return axios.get(`${config.api_base_url}v1/configuration/emails`)
    },
}